import { WikipediaPage } from './types';
import React from 'react';
import { truncateString } from '../../../helpers/functions';

export const WikipediaCard = ({
  post: { extract, title, permalink },
}: {
  post: WikipediaPage;
}) => {
  return (
    <div
      className={`
        flex
        shadow-md
        border-1
        rounded-lg
        p-4
        ${permalink ? 'cursor-pointer' : 'pointer-events-none'}
        border-grey-10
        dark:border-grey-80
        hover:border-grey-50
      `}
      onClick={() => permalink && window.open(permalink)}
    >
      <div className={'block'}>
        <div className={'my-2 font-semibold'}>
          <span className={'text-container'}>{title}</span>
        </div>
        <div className={'my-2 text-sm'}>{truncateString(extract, 300)}</div>
      </div>
    </div>
  );
};
